import { render, staticRenderFns } from "./NewFileIcon.vue?vue&type=template&id=5f5a3267"
import script from "./NewFileIcon.vue?vue&type=script&lang=js"
export * from "./NewFileIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports